// extracted by mini-css-extract-plugin
export default {"colorButton":"ColorPicker_colorButton__78RyZ","picker":"ColorPicker_picker__ja0H-"};